import { Controller } from "..";
import { Client } from "../client";
import { AppSettings } from "../models/app";

export const fetchAppSettings = (): Promise<AppSettings> =>
	Client.instance.get(Controller.Settings);
